import { memo, type ReactNode } from 'react'

import type { DataTableViewCommonProps } from './data-table.interface'
import { DataTableLoaded } from './data-table-loaded.molecule'
import { DataTableLoading } from './data-table-loading.molecule'

interface DataTableStateRendererProps<TData> extends DataTableViewCommonProps<TData> {
  isLoading: boolean
}

const DataTableStateRendererInner = <TData,>(p: DataTableStateRendererProps<TData>): ReactNode => {
  if (p.isLoading) {
    return (
      <DataTableLoading
        toolbar={p.toolbar}
        columnCount={p.columnList.length}
        hasCheckbox={p.isSelectable}
        hasActions={p.tableState.hasActions}
        className={p.className}
      />
    )
  }
  return <DataTableLoaded {...p} />
}

export const DataTableStateRenderer = memo(
  DataTableStateRendererInner
) as typeof DataTableStateRendererInner
